package org.bsvac.bsvac_kmp.ui.subscreens

import androidx.compose.animation.animateContentSize
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.text.input.rememberTextFieldState
import androidx.compose.material3.Button
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.bsvac.bsvac_kmp.MainViewModel

@Composable
fun DevSettings(modifier: Modifier = Modifier,
                currentFontSize: TextUnit,
                onFontSizeUpdated: (TextUnit) -> Unit
) {
    var expanded by remember { mutableStateOf(false) }
    val modifier = if (expanded) {
        modifier.fillMaxHeight().fillMaxWidth().clickable(interactionSource = null, indication = null){}
    } else {
        modifier.size(20.dp).clickable { expanded = true}
    }
    Box(modifier = modifier.background(Color(1f, 0f, 0f, .4f))
        .animateContentSize()

    ) {
        if (expanded) {
            Column {
                Button(onClick = { expanded = false }) {
                    Text("Close Dev Settings")
                }

                val updateFontState = rememberTextFieldState(initialText = "$currentFontSize")
                Row {
                    TextField(state = updateFontState)
                    Button(onClick = {
                        val currentInput = updateFontState.text.toString()
                        val inputSize = currentInput.replace(".sp", "").toFloat().sp
                        onFontSizeUpdated(inputSize)
                    }) {
                        Text("Update font size")
                    }
                }
            }

        }
    }
}